import { render, staticRenderFns } from "./PcOptimize.vue?vue&type=template&id=1b448075&scoped=true"
import script from "./PcOptimize.vue?vue&type=script&lang=js"
export * from "./PcOptimize.vue?vue&type=script&lang=js"
import style0 from "./PcOptimize.vue?vue&type=style&index=0&id=1b448075&prod&lang=scss&scoped=true"
import style1 from "./PcOptimize.vue?vue&type=style&index=1&id=1b448075&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b448075",
  null
  
)

export default component.exports